module.exports = __webpack_public_path__ + "img/main.01506f13.jpg";